export { default } from "./mergeSlotProps.mjs";